import { css } from '@emotion/css'
import { spacing, borderRadius, fontSize, fontWeight, fontFamily } from '../../styles'
import { colors } from '../../themes'

const styles = {
  error: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    fontStyle: 'italic',
    lineHeight: 1.2,
    borderRadius: borderRadius.default,
    padding: spacing.default,
    color: colors.mandy,
    backgroundColor: colors.linen,
    wordBreak: 'break-word',
    boxSizing: 'border-box',
  }),
}

export default styles

export const errorScope = scope => {
  switch (scope) {
    case 'fieldTop':
      return css({
        marginBottom: spacing.default,
      })

    case 'fieldBottom':
      return css({
        marginTop: spacing.default,
      })

    case 'generalMiddle':
      return css({
        marginTop: spacing.medium,
        marginBottom: spacing.medium,
      })

    default:
      return css({
        marginBottom: spacing.medium,
      })
  }
}
